import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ViewAssetModalPage } from 'src/app/modals/view-asset-modal/view-asset-modal.page';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { Scene } from 'src/app/models/Scene';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';

@Component({
  selector: 'app-video-media-management',
  templateUrl: './video-media-management.component.html',
  styleUrls: ['./video-media-management.component.scss'],
})
export class VideoMediaManagementComponent implements OnInit {

  public assetsOnAssetManagementPageList: MediaAsset[] = [];
  public assetsOnAssetManagementPageListCopy: MediaAsset[] = [];
  public videoSearchTerm: string;
  public searchNotFound: boolean = false;
  private _isModalOpen: boolean = false;

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('assetsOnMediaManagementPage') assetsOnMediaManagementPage: MediaAsset[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  constructor(
    public assetTypeService: AssetTypeService,
    public deepCopyService: DeepCopyService,
    public modalController: ModalController,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    let assetTypeId= this.assetTypeService.getId('Video');
    this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnMediaManagementPage.filter((x: any) => x.isBackground == "false" && x.assetTypeId == assetTypeId));
    this.assetsOnAssetManagementPageListCopy = this.deepCopyService.deepCopy(this.assetsOnMediaManagementPage.filter((x: any) => x.isBackground == "false" && x.assetTypeId == assetTypeId));
  }

  searchByVideo(event) {
    let name: string = event.target.value ? event.target.value : '';

    this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageListCopy);
    var assets = this.assetsOnAssetManagementPageList.filter(x => x.name.toLowerCase().includes(name.toLowerCase()));
    if (assets.length === 0) {
      this.searchNotFound = true;
      this.assetsOnAssetManagementPageList = this.deepCopyService.deepCopy(this.assetsOnAssetManagementPageListCopy);
    }
    else {
      this.searchNotFound = false;
      this.assetsOnAssetManagementPageList = assets;
    }
  }

  async previewAsset(mediaAsset: any) {

    if (this._isModalOpen === true) return;
    this._isModalOpen = true;

    var oldSrc = mediaAsset.src;
    mediaAsset.src = this.sanitizer.bypassSecurityTrustUrl(oldSrc);

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetType + '-modal',
      componentProps: {
        "assetModalData": mediaAsset
      }
    });

    modal.onDidDismiss().then(() => {
      mediaAsset.src = oldSrc;
      this._isModalOpen = false;
    });

    return await modal.present();

  }

}
